import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {ref, watch} from "vue";

interface Props {
  details?: PersonDetails
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationOfficeEditComponent',
  props: {
    details: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {

const _form = ref<InstanceType<typeof SogForm> | null>(null)

const props = __props

const _emails = ref<string>("")
const _prefixes = ref<string>("")
const _districtKeys = ref<string>("")

function validate(): boolean {
  return _form.value?.validate() ?? false;
}

watch(props, () => {
  _emails.value = props.details?.getValue(PersonDetailsId.RegistrationOfficeEmails) ?? ""
  _prefixes.value = props.details?.getValue(PersonDetailsId.RegistrationOfficePrefixes) ?? ""
  _districtKeys.value = props.details?.getValue(PersonDetailsId.RegistrationOfficeDistrictKeys) ?? ""
}, {immediate: true})

function getDetails(): PersonDetails | undefined {
  if (!validate()) return undefined;
  const details = new PersonDetails(props?.details?.getValues());
  details.setValue(PersonDetailsId.RegistrationOfficeEmails, _emails.value.trim())
  details.setValue(PersonDetailsId.RegistrationOfficePrefixes, _prefixes.value.trim().toUpperCase())
  details.setValue(PersonDetailsId.RegistrationOfficeDistrictKeys, _districtKeys.value.trim())
  return details;
}

__expose({
  validate,
  getDetails
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form
  }, {
    default: _withCtx(() => [
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _emails.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_emails).value = $event)),
            placeholder: "E-Mail-Adressen (mit ; getrennt)",
            name: "registrationOfficeEmails"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _prefixes.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_prefixes).value = $event)),
            placeholder: "Kennzeichen-Präfixe (mit ; getrennt, z. B. OS;OSL)",
            name: "registrationOfficePrefixes"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _districtKeys.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_districtKeys).value = $event)),
            placeholder: "Kreisschlüssel (mit ; getrennt; bei mehreren Behörden mit gleichem Schlüssel mit Zusatzziffer, z. B. 03159/1)",
            name: "registrationOfficeDistrictKeys"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})